// Basic
import PropTypes from 'prop-types';
// Components
import Entity from '@/common-utils/components/renders/entity/Entity';
// Common
import BANK_CODES from '../../enums/BankCodes';
import TooltipHelper from '@/common-utils/components/renders/tooltip/TooltipHelper';

/**
 * @param root0
 * @param root0.bankCode
 * @param root0.label
 * @param root0.namespace
 * @returns {JSX} RenderBankCode
 */
function RenderBankCode({ bankCode, label = undefined, namespace = undefined }) {
    // Constants
    const bankCodeItemFound = BANK_CODES.find(bankCodeItem => bankCodeItem.bankCode === bankCode) ?? { bankCode: bankCode };

    return (
        <TooltipHelper
            trigger={
                <div className='flex flex-col text-left w-32'>
                    <div>
                        {
                            label && namespace ?
                                <Entity entity={label} namespace={namespace} data={{ bankCode: bankCodeItemFound.bankCode }} />
                                : bankCodeItemFound.bankCode
                        }
                    </div>
                    {bankCodeItemFound.bankLabel ?
                        <div className='flex'>
                            <small className='whitespace-nowrap overflow-hidden text-ellipsis'>
                                {bankCodeItemFound.bankLabel}
                            </small>
                        </div>
                        : false
                    }
                </div>
            }
            content={
                <div className='flex flex-col text-left'>
                    <div>
                        {
                            label && namespace ?
                                <Entity entity={label} namespace={namespace} data={{ bankCode: bankCodeItemFound.bankCode }} />
                                : bankCodeItemFound.bankCode
                        }
                    </div>
                    {bankCodeItemFound.bankLabel ?
                        <div className='flex'>
                            <small>
                                {bankCodeItemFound.bankLabel}
                            </small>
                        </div>
                        : false
                    }
                </div>
            }
        />
    );
}

RenderBankCode.propTypes = {
    bankCode: PropTypes.string,
    label: PropTypes.string,
    namespace: PropTypes.string
};

export default RenderBankCode;